import Action from "./Action.vue";
import Condition from "./Condition.vue";

export default [
    {
        label: "执行动作",
        nodeType: "Action",
        component: Action,
        endpoints: (data) => {
            const ret = [
                {
                    target: true,
                    anchor: [0, 0, -1, 0, "Left"],
                    maxConnections: -1,
                },
            ];
            const nextId = data.actions && data.actions[0] ? data.actions[0].actionId : "";
            if (nextId) {
                ret.push({
                    elemId: nextId,
                    source: true,
                    anchor: [0, 0, 1, 0, "Right"],
                    maxConnections: 1,
                });
            }
            return ret;
        },
        init: () => {
            return {
                name: "新建动作节点"
            };
        }
    },
    {
        label: "条件判断",
        nodeType: "Condition",
        component: Condition,
        endpoints: (data) => {
            const conditionEnpoints = (data.conditions || []).map(condition => ({
                maxConnections: 1,
                elemId: condition.conditionId,
                source: true,
                anchor: [0, 0, 1, 0, "Right"],
            }));
            return [
                {
                    target: true,
                    anchor: [0, 0, -1, 0, "Left"],
                    maxConnections: -1,
                },
                ...conditionEnpoints
            ];
        },
        init: () => {
            return {
                name: "新建条件节点",
                conditions: [],
            };
        }
    },
];
